const feature = {
  id: "_animations",
  async applyAsset(meshes, _root, ctx) {
    const [{ parseAnimationData }, { createAnimationGroups }] = await Promise.all([import('./gltf-animation.js'), import('../animation/animation-group.js')]);
    const animData = parseAnimationData(ctx._json, ctx._binChunk, meshes, ctx._parentMap, ctx._worldMatrixCache, ctx._nodeMap, ctx._boneOverrides);
    if (!animData) {
      return {};
    }
    return { animationGroups: createAnimationGroups(animData) };
  }
};

export { feature as default };
//# sourceMappingURL=gltf-feature-animations.js.map
